if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      for (let item of MutationList) {
        if (
          item.target.localName === "drawer-cart" || item.target.classList.contains("cart__drawer__prices")
        ) {
          setTimeout(()=>{
             updateSubtotalVatText();
          }, 500)
          BSS_B2B.observer.cartSubject.listenCartCheckout();
        }
        if (
          item.target.classList.contains("cart-table__checkout")
        ) {
          BSS_B2B.observer.cartSubject.listenCartCheckout();
        }        
        if (
          item.target.id === "price-product-quick-view" ||
          item.target.classList.contains("bss-price-main")
        ) {
          BSS_B2B.observer.productSubject.notifyObserver(
            "ProductMutate",
            "ProductPriceMutate"
          );
        }
        if (item.target.localName === "product-quick-view-component") {
          document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`));
        }
        if (
          item.target.classList.contains("predictive-search") &&
          item.target.classList.contains("predictive-search--header")
        ) {
          handleCartDrawerFooterMutation();
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);

  setTimeout(()=>{
     updateSubtotalVatText();
  }, 2000)
  
  async function handleCartDrawerFooterMutation() {
    const res = await BSS_B2B.storage.productStorage.load();
    if (res) {
      if (
        res.notExistProductIds?.length ||
        res.productIds?.length ||
        res.variantIds?.size
      ) {
        BSS_B2B.observer.productSubject.notifyObserver(
          "LazyProduct",
          "LoadedLazyProduct",
          {
            ...res,
          }
        );
      }
    }
  }
  function updateSubtotalVatText() {
    const dataTranslateVat = {
      en: {
        excluded_vat_text: "exc. VAT",
        included_vat_text: "inc. VAT",
      },
      de: {
        excluded_vat_text: "exkl. MwSt",
        included_vat_text: "inkl. MwSt",
      },
      fr: {
        excluded_vat_text: "Hors TVA",
        included_vat_text: "TTC",
      },
    };

    const lang = document
      .querySelector(
        ".footer__language .localization-dropdown__item-link[active-link]"
      )
      .getAttribute("data-value");

    const vatText = dataTranslateVat[lang] || dataTranslateVat['de'];

    let subtotalExcludedVat = document.querySelector(
      ".cart-drawer__checkoutButtons .bss-b2b-price-no-vat"
    );
    if (subtotalExcludedVat) {
      subtotalExcludedVat.innerText = subtotalExcludedVat.innerText.replace(
        /(\d+[.,]?\d*)\s.*$/,
        `$1 ${vatText.excluded_vat_text}`
      );
    }

    let subtotalIncludedVat = document.querySelector(
      ".cart-drawer__checkoutButtons .bss-b2b-price-has-vat"
    );
    if (subtotalIncludedVat) {
      subtotalIncludedVat.innerText = subtotalIncludedVat.innerText.replace(
        /(\d+[.,]?\d*)\s.*$/,
        `$1 ${vatText.included_vat_text}`
      );
    }
  }
  
}
